import { Volume2, VolumeX } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";
import { BarControl } from "@/components/flowly/GenerationBar/BarControl";

interface SoundToggleButtonProps {
  enabled: boolean;
  onToggle: () => void;
  alwaysOn?: boolean;
}

export const SoundToggleButton = ({
  enabled,
  onToggle,
  alwaysOn,
}: SoundToggleButtonProps) => {
  const { t } = useLanguage();

  if (alwaysOn) {
    return (
      <BarControl
        as="div"
        className="font-bold text-xs bg-teal-500/80 border-teal-400/50 shadow-[0_0_12px_rgba(45,212,191,0.25)] cursor-default hover:bg-teal-500/80 hover:border-teal-400/50"
      >
        <Volume2 className="w-4 h-4 text-white" />
        <span className="text-white">{t.generate.soundAlwaysOn}</span>
      </BarControl>
    );
  }

  return (
    <BarControl
      onClick={onToggle}
      className={cn(
        "font-bold text-xs",
        enabled && "bg-teal-500/80 hover:bg-teal-500/70 border-teal-400/50 shadow-[0_0_12px_rgba(45,212,191,0.25)]",
      )}
    >
      {enabled ? (
        <Volume2 className="w-4 h-4 text-white" />
      ) : (
        <VolumeX className="w-4 h-4 text-white/60" />
      )}
      <span className="text-white">
        {enabled ? t.generate.soundEnabled : t.generate.addSound}
      </span>
    </BarControl>
  );
};
